import removeTypenames from '~/util/removeTypenames';
import type { BiedwijzerAppStatus } from '../..';
import findDifference from '~/util/findDifference';
import { equals } from 'ramda';

const getChangeCount = (
  initialValues: BiedwijzerAppStatus | null,
  currentValues: BiedwijzerAppStatus | null,
) => {
  const res = findDifference({
    obj1: removeTypenames(initialValues || {}),
    obj2: removeTypenames(currentValues || {}),
    fieldsToOmit: [
      ['widgetAppConfigurationItems'],
      ['officeNumbers'],
      ['content', 'addressSearch', 'image', 'url'],
      ['content', 'aboutUs', 'image', 'url'],
    ],
  });

  const officeNumbersChanged = equals(
    initialValues?.officeNumbers || [],
    currentValues?.officeNumbers || [],
  )
    ? 0
    : 1;

  const imageFields: Array<'addressSearch' | 'aboutUs'> = [
    'addressSearch',
    'aboutUs',
  ];

  imageFields.forEach(field => {
    const prevImage = initialValues?.content?.[field]?.image ?? null;
    const nextImage = currentValues?.content?.[field]?.image ?? null;

    const imagesEqual = (() => {
      if (!prevImage && !nextImage) return true;
      if (!prevImage || !nextImage) return false;

      if (prevImage.__typename !== nextImage.__typename) return false;

      if (
        prevImage.__typename === 'AssetImage' &&
        nextImage.__typename === 'AssetImage'
      ) {
        return prevImage.assetId === nextImage.assetId;
      }

      if (
        prevImage.__typename === 'DHImage' &&
        nextImage.__typename === 'DHImage'
      ) {
        return prevImage.s3key === nextImage.s3key;
      }

      return false;
    })();

    if (!imagesEqual) res.differenceCount += 1;
  });

  return res.differenceCount + officeNumbersChanged;
};

export default getChangeCount;
